import { render, staticRenderFns } from "./IBSUF.vue?vue&type=template&id=1d5dd63c&"
import script from "./IBSUF.vue?vue&type=script&lang=js&"
export * from "./IBSUF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports